import Pubnub from 'pubnub';
import _ from 'lodash';
import { createAsyncThunk } from '@reduxjs/toolkit';

import { RootState } from '../../..';
import { ChannelMetaDataCustom } from '../../types';
import { getErrorText } from '../helpers';

export const removeListenerFromAllowToSpeakList = createAsyncThunk<
  Pubnub.SetChannelMetadataResponse<ChannelMetaDataCustom>,
  { roomId: string; listenerId: string },
  { rejectValue: string }
>('pubnub/removeListenerFromAllowToSpeakList', async (data, { rejectWithValue, getState }) => {
  try {
    const pubnubReducer = (getState() as RootState).pubnub;
    const { listenersAllowedToSpeak } = pubnubReducer;

    const payload = _.filter(listenersAllowedToSpeak, (l) => l.id !== data.listenerId);

    if (pubnubReducer.pubnub) {
      const result = pubnubReducer.pubnub.objects.setChannelMetadata({
        channel: data.roomId,
        data: {
          custom: { listenersAllowedToSpeak: JSON.stringify(payload) },
        },
      });

      return result;
    } else {
      throw new Error('PubnubInstanceIsNull');
    }
  } catch (e) {
    return rejectWithValue(getErrorText(e as Error));
  }
});
